import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CreateContactListComponent } from "./pages/create-contact-list/create-contact-list.component";
import { GetListsComponent } from "./pages/get-lists/get-lists.component";
import { DetailedListComponent } from "./pages/detailed-list/detailed-list.component";
import { QualifiedListComponent } from "./pages/qualified-list/qualified-list.component";

const routes: Routes = [
  {
    path: "gerar",
    component: CreateContactListComponent,
  },
  {
    path: "listas",
    component: GetListsComponent,
  },
  {
    path: "listas/:id",
    component: DetailedListComponent,
  },
  {
    path: "lista-qualificados",
    component: QualifiedListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactsRoutingModule {}
